import FieldController from '../field.controller';

import {
  isString,
  isArray,
  normalizeIdentifier,
} from '../../../util';

class RankFieldController extends FieldController {
  constructor($scope, $q, $translate, $log, $timeout) {
    "ngInject";
    super($scope, $q, $translate, $log, $timeout);

    this._treeOptions = {
      accept: event => {
        this.$log.log("RankFieldController accept() returning true");
        return true;
      },

      beforeDrop: event => {
        this.$log.log("RankFieldController beforeDrop() returning true");
        return true;
      },

      dropped: event => {
        this.$log.log("RankFieldController dropped() returning undefined. arguments:", arguments);
        this.$timeout(() => {
          this.$log.log("RankFieldController updating positions");
          this.updateRanksFromArrayPositions(this.sortedOptionInfos);
          this.updateResponseValue();
        });
      },
    };
  }

  $onInit() {
    super.$onInit();
    this.$timeout(() => {
      this._sortedOptionInfos = this._sortOptions(this.$scope.filteredOptions, this.value);
      this._ranks = [];
      for (let x = 1; x <= this._sortedOptionInfos.length; x++) {
        this._ranks.push(x);
      }
    });
  }

  get treeOptions() {
    return this._treeOptions;
  }

  set sortedOptionInfos(sortedOptionInfos) {
    this.$log.info("RankFieldController set sortedOptionInfos=", sortedOptionInfos);
    this._sortedOptionInfos = sortedOptionInfos;
    this.updateResponseValue();
  }

  get sortedOptionInfos() {
    return this._sortedOptionInfos;
  }

  get numOptions() {
    return this.sortedOptionInfos.length;
  }

  get ranks() {
    return this._ranks;
  }

  changedRank(optionInfo) {
    this.$log.log("RankFieldController changedRank() args:", arguments);

    const oldRank = parseInt(optionInfo.rank);
    const newRank = parseInt(optionInfo.newRank);
    if (newRank && newRank !== oldRank) {
      const updatedOptionInfos = this.updateIndexInArray(oldRank - 1, newRank - 1, this.sortedOptionInfos);
      this.updateRanksFromArrayPositions(updatedOptionInfos);
      this.sortedOptionInfos = updatedOptionInfos;
      this.updateResponseValue();
    }
  }

  updateResponseValue() {
    const sortedOptionIds = this.sortedOptionInfos
      .map(optionInfo => normalizeIdentifier(optionInfo.option.id));
    this.value = JSON.stringify(sortedOptionIds);
  }

  _sortOptions(options, value = null) {
    if (!isArray(options)) {
      this.$log.warn("RankFieldController._sortOptions don't have options, returning empty array");
      return [];
    }

    let inputOptionIds;
    if (isArray(value)) {
      inputOptionIds = value;
    } else if (isString(value) && value.trim().startsWith('[')) {
      inputOptionIds = JSON.parse(value);
    } else if (isString(value)) {
      inputOptionIds = value.split(/[|,]/).filter(id => id.trim() !== '');
    } else {
      inputOptionIds = [];
    }

    if (!isArray(inputOptionIds)) {
      this.$log.warn("RankFieldController._sortOptions() don't have array of values; returning options");
      return options;
    }

    const sortedOptionInfos = [];
    const usedOptionIdMap = {};

    // Create mapping of option id => option
    const optionsById = options.reduce((pre, cur) => {
      const id = normalizeIdentifier(cur.id);
      pre[id] = cur;
      return pre;
    }, {});

    const addOptionByIdIfNotPresent = optionId => {
      const id = normalizeIdentifier(optionId);
      const option = optionsById[id];
      if (option && !usedOptionIdMap[id]) {
        const rank = sortedOptionInfos.length + 1;
        const optionInfo = {
          option,
          rank,
          newRank: rank,
        };
        sortedOptionInfos.push(optionInfo);
        usedOptionIdMap[id] = {};
      }
    };

    inputOptionIds.forEach(id => addOptionByIdIfNotPresent(id));
    options.forEach(option => addOptionByIdIfNotPresent(option.id));

    return sortedOptionInfos;
  }

  updateIndexInArray(oldIndex, newIndex, items) {
    const updatedItems = [...items];

    // Remove from old position
    const removedItems = updatedItems.splice(oldIndex, 1);

    // Add to new position
    updatedItems.splice(newIndex, 0, removedItems[0]);

    return updatedItems;
  }

  updateRanksFromArrayPositions(optionInfos) {
    optionInfos.forEach((optionInfo, idx) => {
      const rank = idx + 1;
      optionInfo.rank = rank;
      optionInfo.newRank = rank;
    });
  }
}

export default RankFieldController;
